<template>
	<div class="dialogContent jobModule">
		<div class="dialogMap">
			<div id="containers" class="myMapDialog"></div>
			<div class="dialogMapText">
				<table>
					<tr>
						<td>监控编号：{{this.dataTitle.imei}}</td>
						<td>机具型号：{{this.dataTitle.productModel}}</td>
						<td>出厂编号：{{this.dataTitle.factoryCode}}</td>
						<td>作业时间：{{this.dataTitle.operatTime}}</td>
						<td>作业地区：{{this.dataTitle.workArea}}</td>
						<!--<td>
							<el-checkbox class="showProLinesCheck" v-model="showProLinesCheck" size="small">区县边界</el-checkbox>
						</td>-->
					</tr>
					<!--<tr>
									<td>时长：{{ runTimeDay }}</td>
									<td>里程：{{this.dataTitle.mileageDay}}</td>
									<td>预计面积：{{operatArea}}</td>
								</tr>-->
				</table>

			</div>

			<div id="tools" v-show="statusStatic">
				<div class="btns">
					<ul class="speedUp" v-show="popVisible">
						<li v-for="(item,index) in speedList" :class="{'speedActive':index==speedIsActive}" @click.stop="handlePlay('accelerate',index)" :key="index">{{item.speedTimes}}</li>
					</ul>
					<dl :class="calendarFlag == true?'img-onlyRead':''" @click.stop="speedChange('slowdown')">
						<dt id="moderatingBtn">
												<img src="/static/bofang/jiansu.png" />
											</dt>
						<dd>减速</dd>
					</dl>
					<dl>
						<dt id="pauseBtn" @click='handlePlay(operationForPauseAndContinue)'>
									<img :src="continueOrStopUrl" id="starImg"/>
									
								</dt>
						<dd id="pauseBtns">开始</dd>
					</dl>
					<dl :class="calendarFlag == true?'img-onlyRead':''" @click.stop="speedChange('accelerate')">
						<dt id="acceleratedBtn">
												<img src="/static/bofang/jiasu.png" />
											</dt>
						<dd>加速</dd>
					</dl>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Gmap from "../../map/js/fzTianmap.js";
	import Api from '../../Serves/net-api.js'
	import Http from '../../Serves/net-http.js'
	import { mapState, mapActions, mapMutations } from "vuex";
	import 'maptalks/dist/maptalks.css'
	import * as maptalks from 'maptalks'
	import TalksMap from '../../map/js/initMapTalks.js'

	export default {
		name: "MonitorDetails",
		components: {},
		computed: {
			...mapState({
				details: state => state.details,
				//      imei:state=>state.imei,
				time: state => state.time,
				handleName: state => state.kName,
			}),
		},

		data() {
			return {
				dialogGamps: new Gmap(),
				TalksMapDialog: new TalksMap(),
				isloading: true,
				nodata: false,
				// loading:false,//表格加载状态
				checkZreo: false,
				total: 1,
				pageSize: '',
				currentPage: 1,
				checkcurrentPage: 10,
				currentPage1: 5,
				currentPage2: 5,
				currentPage3: 5,
				currentPage4: 4,
				formInline: {
					user: '',
					region: ''
				},
				value: [],
				value2: '',
				tableData: [],
				dialogDetail: false,
				dataTitle: '',
				runTimeDay: '',
				operatArea: '',
				calendarFlag: true,
				startContinue: "start",
				operationForPauseAndContinue: "start",
				map: "",
				stopedIndex: 0,
				trackList: [],
				zanting: require('/static/bofang/zanting.png'),
				kaishi: require('/static/bofang/start.png'),
				continueOrStopUrl: require('/static/bofang/start.png'),
				tingzhi: require('/static/bofang/tingzhi.png'),
				speedList: [{
					'speedTimes': '0.5X',
					'speed': 800,
				}, {
					'speedTimes': '1X',
					'speed': 400,
				}, {
					'speedTimes': '2X',
					'speed': 200,
				}, {
					'speedTimes': '3X',
					'speed': 133,
				}],
				speedIsActive: 1,
				popVisible: false,
				allTrackList: [],
				showProLinesCheck: false

			}
		},
		props: ['imei', 'id', 'statusStatic', 'collectTime', 'deviceType', 'qrNumber'],
		watch: {
			handleName(newVal, oldVal) {
				if(newVal == 'end') {
					this.operationForPauseAndContinue = 'start'
					document.getElementById("pauseBtns").innerHTML = "开始";
					this.continueOrStopUrl = this.kaishi;
					this.calendarFlag = true;
				}
			},
			imei(newVal, oldVal) {
				this.allTrackList = []
			},
			showProLinesCheck(newVal, oldVal) {
				if(newVal) {
					this.mapCenter = this.TalksMapDialog.map.getCenter()
					var parmse = {
						lng: this.mapCenter.x,
						lat: this.mapCenter.y
					}
					Api.doPost(Http.gis.getCountyBorderByViewCenter, parmse, false, (res) => {
						this.TalksMapDialog.drawCountyLine(res.result);
					})
				} else {
					this.TalksMapDialog.countyLayer.clear()
				}
			}
		},
		beforeDestroy() {
			//清除当前页定时器
			if(this.requestTimer) {
				clearInterval(this.requestTimer);
				this.timer = null;
			}
			//清除小车跑定时器
			if(this.TalksMapDialog._timer || this.TalksMapDialog.i > 0) {
				clearInterval(this.TalksMapDialog._timer);
				this.TalksMapDialog._timer = ''
			}

		},
		mounted() {
			this.TalksMapDialog.sendThis(this);
			let this_ = this;
			this.TalksMapDialog.sendThis(this);
			document.addEventListener('click', function(e) {
				if(this_.popVisible === true) {
					this_.popVisible = false
				}
			})
		},
		methods: {
			initMap() {
				if(this.TalksMapDialog.map) {
          this.TalksMapDialog.map.remove()
        }
				this.TalksMapDialog.init("containers", 16);
			},
			getCenterPos() {
				var parmse = {
					imei: this.imei,
					sendDate: this.collectTime
				}
				Api.doPost(Http.gis.findBlocks, parmse, false, (res) => {
					if(res && res.result && res.result.lng) {
						this.lngLatCenter = {
							x: Number(res.result.lng),
							y: Number(res.result.lat)
						}
					}

				})
			},

			// 获取轨迹数据
			trackViewing() {
				let this_ = this;
				var parmse = {
					imei: this.imei,
          deviceType: this.deviceType,
					startTime: this.collectTime,
          qrNumber: this.qrNumber
				}
				Api.doPost(Http.test + "/purchaseSubsidyMonitor/findTrack", parmse, false, (res) => {
					var List = res.result.list
					this.trackList = res.result.list
					// this.dataTitle = res.result
					this.runTimeDay = res.result.runTimeDay === '' ? '' : res.result.runTimeDay + '时'
					this.operatArea = res.result.operatArea === '' ? '' : res.result.operatArea + '亩'
					this.lineArr = List
					if(this_.lngLatCenter) {
						this_.TalksMapDialog.map.setCenter(this_.lngLatCenter)
					} else {
						let Coordinate = {
							x: Number(List[0].lng),
							y: Number(List[0].lat)
						}
						this_.TalksMapDialog.map.setCenter(Coordinate)
					}
					this_.TalksMapDialog.drawLine(List);
				})
			},
			speedChange(typeName) {
				if(this.popVisible) {
					if(typeName == 'slowdown') {
						this.speedIsActive = this.speedIsActive == 0 ? 0 : this.speedIsActive - 1
					} else {
						let len = this.speedList.length - 1;
						this.speedIsActive = this.speedIsActive == len ? len : this.speedIsActive + 1
					}
					this.speedNum = this.speedList[this.speedIsActive].speed;
					if(this.trackList.length > 0) {
						this.TalksMapDialog.playBack(
							this.trackList,
							typeName,
							this.stopedIndex,
							this.stopedIndex > 0,
							undefined, this.speedNum
						);
					}
				} else {
					this.popVisible = true
				}

			},
			handlePlay(typeName, index) {
				if(index || index === 0) {
					this.speedNum = this.speedList[index].speed
				}
				if (document.getElementById('pauseBtns').innerHTML === '开始') {
					typeName = 'start'
				}
				if(typeName === "start") { //开始
					let name_ = this.$store.state.kName
					this.$store.state.kName = name_ ? '' : 'start'
					//					this.clearPolyline();
					this.stopedIndex = 0;
					this.calendarFlag = false;
					this.operationForPauseAndContinue = 'pause'
					document.getElementById("pauseBtns").innerHTML = "停止";
					document.getElementById('starImg').src = require('../../../static/bofang/tingzhi.png')
					this.continueOrStopUrl = this.tingzhi;
					this.speedNum = 400
					this.speedIsActive = 1
				} else if(typeName === "pause") { //停止
					this.stopedIndex = this.TalksMapDialog.i;
					this.operationForPauseAndContinue = 'continue'
					document.getElementById("pauseBtns").innerHTML = "继续";
					this.continueOrStopUrl = this.kaishi;
					this.calendarFlag = true;
					this.popVisible = false;

				} else if(typeName === "continue") { //继续
					this.operationForPauseAndContinue = 'pause'
					document.getElementById("pauseBtns").innerHTML = "停止";
					this.continueOrStopUrl = this.tingzhi;
					this.calendarFlag = false;

				} else if(typeName === "stop") {
					this.TalksMapDialog.lastLinePoints = []
					this.calendarFlag = true;
					this.popVisible = false;
				} else if(typeName === "accelerate") { //加速减速
					this.speedIsActive = index
					this.speedNum = this.speedList[index].speed;
				}
				if(this.trackList.length > 0) {
					this.TalksMapDialog.playBack(
						this.trackList,
						typeName,
						this.stopedIndex,
						this.stopedIndex > 0,
						undefined, this.speedNum
					);
				}
			},
			//实时轨迹数据
			trackMove(firstLine) {
				let this_ = this;
				var parmse = {
					imei: this.imei,
					startTime: this.getGjTime,
					trackType: 0
				}
				Api.doPost(Http.gis.gps, parmse, false, (res) => {
					this.getGjTime = res.result.startTime;
					var List = res.result.trackList
					this.trackList = res.result.trackList
					this.trackList.forEach((item, index) => {
						this.allTrackList.push(item)
					})

					if(this.lngLatCenter) {
						this.TalksMapDialog.map.setCenter(this.lngLatCenter)
					} else {
						let dataLen_ = this_.allTrackList.length;
						let Coordinate = {
							x: Number(this_.allTrackList[dataLen_ - 1].lng),
							y: Number(this_.allTrackList[dataLen_ - 1].lat)
						}
						this.TalksMapDialog.map.setCenter(Coordinate)
					}

					if(List && List.length > 0) {
						this.getGjTime = res.result.startTime;
						this.currentPageStartRunningIndex = List.length - 1;
						this.lastRequestData = List[this.currentPageStartRunningIndex]
						this.TalksMapDialog.addMarker(firstLine, List, this.lastRequestData, '')
					}

				})

			},

		}
	}
</script>

<style scoped>
	td {
		/* overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis !important; */
		word-break: break-all;
  		white-space: nowrap;
	}
	
	.el-header {
		height: 0px !important;
	}
	
	.el-table {
		width: 95% !important;
		margin: auto;
		color: #fff;
	}
	
	.details-parameter-tit {
		width: 95% !important;
		margin: auto;
		height: 40px;
		line-height: 40px;
	}
	
	.details-parameter-tit i:nth-child(1) {
		font-size: 22px;
		font-weight: bold;
		color: #75c3ff;
	}
	
	.details-parameter-tit i:nth-child(1):hover {
		font-size: 22px;
		font-weight: bold;
		color: #297af5;
		cursor: pointer;
	}
	
	.details-parameter-tit i:nth-child(2) {
		display: inline-block;
		width: 5px;
		height: 20px;
		position: relative;
		top: 3px;
		background-color: #297af5
	}
	
	.myDetail span {
		display: block;
		font-weight: bold;
		color: #fff;
		font-size: 20px;
		text-align: center;
		margin-top: 20px;
	}
	
	.details-ret {
		display: inline-block;
		margin-left: 20px;
		cursor: pointer;
		float: none !important;
		position: unset !important;
	}
	
	.details-ret span {
		display: inline-block;
		margin-left: 5px;
		font-size: 14px;
		font-weight: unset;
		color: #f45a2b;
	}
	
	.details-parameter {
		/*width: 95% !important;*/
		/*width: 1900px;*/
		margin: 10px 0 0 47px;
	}
	
	.details-parameter-left {
		float: left;
		width: 65%;
		min-width: 771px;
		height: 175px;
		background: url("../../../static/img/details_bg.png") no-repeat;
		background-size: 100% 175px;
		padding: 20px;
		box-sizing: border-box;
		display: inline-block;
		position: relative;
		margin-right: 10px;
		margin-bottom: 10px;
	}
	
	.parameter-njxx {
		height: 30px;
		line-height: 30px;
		font-size: 16px;
		color: #fff;
		width: 40%;
		float: left;
		/*display: inline-block;*/
	}
	
	.parameter-njxx img {
		position: relative;
		top: 5px
	}
	
	.parameter-table {
		margin-top: 10px;
		width: 100%;
		display: inline-block;
	}
	
	.parameter-table tr td {
		padding: 5px 10px;
	}
	
	.parameter-table tr td:nth-child(odd) {
		/*width: 15%;*/
		text-align: right;
		color: #75c3ff;
	}
	
	.parameter-table tr td:nth-child(even) {
		padding-left: 0;
		color: #bad1ef;
		/*min-width: 150px;*/
	}
	
	.details-parameter-ewm {
		float: right;
		display: inline-block;
		margin-right: 10px;
		position: absolute;
		top: 30px;
		right: 10px;
		/*margin-top: -30px;*/
	}
	/*.details-parameter-ewm img{*/
	/*margin: 5px*/
	/*}*/
	
	.details-parameter-right {
		width: 31.5%;
		/*min-width: 480px;*/
		height: 175px;
		display: inline-block;
		box-sizing: border-box;
		background: url("../../../static/img/details_bg2.png") no-repeat;
		background-size: 100% 175px;
	}
	
	.details-parameter-right p {
		font-size: 16px;
	}
	
	.details-running {
		margin-top: 10px;
		margin-left: 20px;
		min-width: 80%;
	}
	
	.details-running tr {
		min-width: 100%;
	}
	
	.details-running tr td:nth-child(odd) {
		text-align: right;
		padding: 5px 10px 5px 0;
		color: #75c3ff;
	}
	
	.details-running tr td:nth-child(even) {
		color: #bad1ef;
	}
	
	.details-table-title {
		width: 95%;
		margin: auto;
		margin-top: 10px;
		font-size: 16px;
		color: #fff;
	}
	
	.details-table-title img {
		position: relative;
		top: 5px
	}
	
	.demonstration {
		font-size: 14px !important;
		color: #75c3ff !important;
	}
	
	@media screen and (max-width:1630px) {
		/* .parameter-table tr td[data-v-52f42fc4]:nth-child(even) {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			max-width: 100px;
		} */
		/*.details-parameter {*/
		/*!*display:none;*!*/
		/*}*/
		/*.details-parameter-left {*/
		/*width: 920px;*/
		/*}*/
		/*.details-running{*/
		/*width: 95%;}*/
		/*.details-parameter-right{*/
		/*width: 55%;*/
		/*}*/
	}
	/*.el-checkbox__inner{*/
	/*background-color:#409EFF !important ;*/
	/*}*/
</style>


// WEBPACK FOOTER //
// src/components/TableList/trackLayer.vue